import React from 'react';

interface WhatsappIconProps {
  className?: string;
}

function WhatsappIcon({ className }: WhatsappIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
      className={className}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.67 20.111a10.53 10.53 0 005.367 1.47h.004A10.54 10.54 0 10.5 11.032a10.443 10.443 0 001.616 5.606l.25.402L1.3 20.927l3.984-1.043.384.228zm8.766-7.535c.28.099 1.727.817 2.02.967v.017l.119.054c.23.104.383.173.443.287.085.474.031.963-.155 1.406-.249.699-1.424 1.332-1.99 1.417a4.038 4.038 0 01-1.854-.116c-.434-.143-.98-.327-1.683-.63-2.706-1.183-4.553-3.82-4.956-4.395a3.15 3.15 0 00-.074-.103c-.148-.188-1.202-1.601-1.202-3.065a3.371 3.371 0 011.03-2.486 1.092 1.092 0 01.785-.372h.555c.02 0 .04 0 .061-.002.175-.008.399-.019.606.513.232.596.831 2.064.905 2.214a.553.553 0 01.02.52c-.072.18-.17.348-.292.498l-.134.163c-.104.129-.206.255-.31.358-.149.147-.304.31-.128.606.443.765.994 1.46 1.636 2.064a8.181 8.181 0 002.356 1.482c.3.15.465.129.636-.075.172-.205.724-.872.933-1.172.209-.3.394-.249.673-.15z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default WhatsappIcon;
